// @flow

import React, { createContext, useContext, type Node } from 'react';
import { type AnalyticsManager } from './types';

const AnalyticsContext = createContext<?AnalyticsManager>(null);

type Props = {|
  children: Node,
  analytics: AnalyticsManager,
|};

export function AnalyticsContextProvider({ children, analytics }: Props): Node {
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalyticsContext(): AnalyticsManager {
  const context = useContext(AnalyticsContext);
  if (!context)
    throw new Error('Analytics: there is no analytics context provided');

  return context;
}
